import { Reducer } from 'redux';

import * as types from './task-modals.types';
import * as constants from './task-modals.constants';

const initialTaskModalState: types.ITaskModalState = {
  open: false,
};

const initialTaskModalsState = {
  taskMembers: initialTaskModalState,
  taskLabels: initialTaskModalState,
  taskLabels1: initialTaskModalState,
  taskChecklist: initialTaskModalState,
  taskAttachment: initialTaskModalState,
  taskShare: initialTaskModalState,
  taskMove: initialTaskModalState,
  taskCopy: initialTaskModalState,
  taskDelete: initialTaskModalState,
};

const initialState: types.ITaskModalsState = {
  ...initialTaskModalsState,
};

// exception to the rule, because of dynamic keys on state, it was easier to bundle everything into one reducer
// in general don't do this, create reducers per property
export const taskModalsReducer: Reducer<types.ITaskModalsState, types.ITaskModalAction> = (
  state = initialState,
  action,
) => {
  if (action.type === constants.STORE_TASK_MODAL_STATUS) {
    const key = (action as types.IStoreTaskModalStatus).payload;

    return {
      ...state,
      [key]: {
        ...state[key],
        open: true,
      },
    };
  } else if (action.type === constants.CLEAR_TASK_MODAL_STATUS) {
    const key = (action as types.IClearTaskModalStatus).payload;

    return {
      ...state,
      [key]: {
        ...state[key],
        open: false,
      },
    };
  } else if (action.type === constants.CLEAR_TASK_MODAL_STATUSES) {
    return initialState;
  }
  return state;
};
